import { createContext, useContext } from 'react';
import { SUBSCRIPTION_MANAGER_INITIAL_STATE } from './SubscriptionManager.constants';
import { tUseSubscriptionManagerContext } from './SubscriptionManager.types';

export const SubscriptionManagerContext = createContext(
  SUBSCRIPTION_MANAGER_INITIAL_STATE,
);

export function useSubscriptionManagerContext(): tUseSubscriptionManagerContext {
  return useContext(SubscriptionManagerContext);
}
